import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent } from '@app/components/input-field/input-field.component';
import { AutoForm } from '@app/interfaces/auto-form.interface';
import { DeviceStatusCreate } from '@app/models/device-status.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-device-status-form',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
    ],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss'
})
export class DeviceStatusFormComponent {
  initialValue = input<DeviceStatusCreate>();
  formChange = output<DeviceStatusCreate>();
  formValid = output<boolean>();

  deviceStatusForm = new FormGroup<AutoForm<DeviceStatusCreate>>({
    name: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    key: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    sort_order: new FormControl<number>(0, { nonNullable: true}),
  });

  constructor() {
    toObservable(this.initialValue).subscribe((initial) => {
      if(initial) {
        Object.keys(initial).forEach(key => {
          // https://stackoverflow.com/a/62438434/3341745
          let prop = key as keyof typeof initial;
          if(initial[prop] != null) {
            this.deviceStatusForm.get(key)?.setValue(initial[prop]);
          }
        });
      }
      this.onChange();
    });
  }

  onChange() {
    this.formValid.emit(this.deviceStatusForm.valid);
    this.formChange.emit(<DeviceStatusCreate>this.deviceStatusForm.value);
  }
}